<template>
  <section>
    <p>What is this all about?</p>
  </section>
</template>

<script>

// Syntax highlighting. Default includes js, html, css. Import all others.
export default {
  name: 'About',
  data() {
    return {
    }
  },
}
</script>
    